<template>
  <window-container class="product-window" @window-return="windowReturn">
    <div style="background-color:#b0c8f5;font-weight:bold;padding-left:2px;border-bottom:1px solid #000;margin-bottom:4px;">
      {{ title }}&nbsp;({{ $route.params.id }})
    </div>
    <div class="card" style="font-weight:bold;">
      Part Number:&nbsp;{{ product.part_no }}&nbsp;&nbsp;&nbsp;
      Description:&nbsp;{{ product.description }}&nbsp;&nbsp;&nbsp;
      Brand:&nbsp;{{ product.brand }}
    </div>
    <div style="padding-left:6px;padding-right:4px;" class="card">
      <el-row :gutter="6" style="margin:0;">
        <el-col :span="16">
          <table class="cystron-table product-table">
            <tr>
              <td class="label">Class</td>
              <td>{{ product.category_name }}&nbsp;-&nbsp;{{ product.class_name }}</td>
            </tr>
            <tr>
              <td class="label">Packing</td>
              <td v-html="product.packing_br"></td>
            </tr>
            <tr>
              <td class="label">Information</td>
              <td v-html="product.information_br"></td>
            </tr>
            <tr>
              <td class="label">Replace Part Number</td>
              <td>
                <div v-for="item in replaces" :key="item.id">
                  <a :href="'/product/' + item.r_product_id + '/' + currentPath">{{ item.part_no }}</a>
                </div>
              </td>
            </tr>
            <tr>
              <td class="label">Remark</td>
              <td v-html="product.product_remark_br"></td>
            </tr>
          </table>
          <div style="padding:2px;">
            <el-button @click="$open('/product-edit/' + $route.params.id, 600, 600)">Edit Item</el-button>
            <el-badge v-if="photos.length > 0" :value="photos.length" type="primary" style="margin-left:10px;">
              <el-button v-if="photos.length > 0" @click="$router.push(`/product/${$route.params.id}/photo`)">Photos</el-button>
            </el-badge>
            <el-button v-else @click="$router.push(`/product/${$route.params.id}/photo`)">Photos</el-button>
            <template v-if="user.role_id <= 2">
              <el-badge v-if="product.doc_remark || docs.length > 0" :value="docs.length" type="primary" style="margin-left:10px;">
                <el-button v-if="product.doc_remark || docs.length > 0" @click="$open('/product-doc/' + $route.params.id)">Doc...</el-button>
              </el-badge>
              <el-button v-else @click="$open('/product-doc/' + $route.params.id)" style="margin-left:10px;">Doc...</el-button>
            </template>
          </div>
        </el-col>
        <el-col :span="8">
          <table class="cystron-table stock-table">
            <tr>
              <td>B2B Qty</td>
              <td>&nbsp;</td>
              <td style="text-align:right;">{{ product.stock_bb }}</td>
            </tr>
            <tr>
              <td style="width:150px;">HK Stock Qty</td>
              <td style="width:30px;">&nbsp;</td>
              <td style="text-align:right;">{{ product.stock_hk }}</td>
            </tr>
            <tr>
              <td style="width:150px;">SZ Stock Qty</td>
              <td style="width:30px;">&nbsp;</td>
              <td style="text-align:right;">{{ product.stock_sz }}</td>
            </tr>
            <tr>
              <td>Incoming</td>
              <td>+</td>
              <td style="text-align:right;">{{ product.incoming_qty }}</td>
            </tr>
            <tr>
              <td><a @click="$open('/product-reserved/' + $route.params.id)" style="text-decoration:underline;">Reserved</a></td>
              <td style="border-bottom:1px solid #000;">-</td>
              <td style="border-bottom:1px solid #000;text-align:right;">{{ product.reserved_qty }}</td>
            </tr>
            <tr>
              <td>Logical Balance</td>
              <td>=</td>
              <td style="text-align:right;text-align:right;">{{ product.stock_hk + product.stock_sz + product.stock_bb + product.incoming_qty - product.reserved_qty }}</td>
            </tr>
            <tr>
              <td>Average Cost</td>
              <td colspan="2" style="text-align:right;">USD0.00</td>
            </tr>
            <tr>
              <td>Last Cost</td>
              <td colspan="2" style="text-align:right;">USD0.00</td>
            </tr>
            <tr>
              <td>Stock Remark</td>
              <td colspan="2" style="text-align:right;">{{ product.stock_remark }}</td>
            </tr>
            <tr v-for="h in holds" :key="h.id">
              <td colspan="3" style="text-align:center;">----hold qty {{ h.qty }} by {{ h.sales_name }}---</td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <hr/>
      <div>
        Goto:
        <el-select :value="currentPath" @change="pathChange" style="width:180px;">
          <el-option label="Details" value="details"></el-option>
          <el-option label="Photo" value="photo"></el-option>
          <el-option label="Quotation/Offer" value="offer"></el-option>
          <el-option label="Requirement" value="require"></el-option>
          <el-option label="Stock" value="stock"></el-option>
          <el-option label="Purchase Order" value="po"></el-option>
          <el-option label="Invoice" value="invoice"></el-option>
        </el-select>
      </div>
    </div>
    <router-view :product-id="$route.params.id" />
  </window-container>
</template>

<script>
export default {
  data () {
    return {
      product: {},
      replaces: [],
      holds: [],
      docs: [],
      photos: []
    }
  },
  computed: {
    title () {
      if (this.$route.path.endsWith('details')) {
        return 'Details'
      }
      if (this.$route.path.endsWith('photo')) {
        return 'Photo'
      }
      if (this.$route.path.endsWith('offer')) {
        return 'Quotation / Offer'
      }
      if (this.$route.path.endsWith('require')) {
        return 'Requirement'
      }
      if (this.$route.path.endsWith('stock')) {
        return 'Stock'
      }
      if (this.$route.path.endsWith('po')) {
        return 'Purchase Order'
      }
      if (this.$route.path.endsWith('invoice')) {
        return 'Invoice'
      }
      return ''
    },
    currentPath () {
      if (this.$route.path.endsWith('details')) {
        return 'details'
      }
      if (this.$route.path.endsWith('photo')) {
        return 'photo'
      }
      if (this.$route.path.endsWith('offer')) {
        return 'offer'
      }
      if (this.$route.path.endsWith('require')) {
        return 'require'
      }
      if (this.$route.path.endsWith('stock')) {
        return 'stock'
      }
      if (this.$route.path.endsWith('po')) {
        return 'po'
      }
      if (this.$route.path.endsWith('invoice')) {
        return 'invoice'
      }
      return ''
    },
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.fetchProduct()
    this.fetchReplaces()
    this.fetchDocList()
    this.fetchPhotoList()
    this.fetchHolds()
  },
  methods: {
    pathChange (val) {
      this.$router.push(`/product/${this.$route.params.id}/${val}`)
    },
    windowReturn () {
      this.fetchProduct()
      this.fetchReplaces()
    },
    fetchProduct () {
      this.$http.get('/dbapi/stock_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          let product = data.list[0]
          product.stock_bb = parseInt(product.stock_bb)
          product.stock_hk = parseInt(product.stock_hk)
          product.stock_sz = parseInt(product.stock_sz)
          product.incoming_qty = parseInt(product.incoming_qty)
          product.reserved_qty = parseInt(product.reserved_qty)
          this.product = product
        }
      })
    },
    fetchReplaces () {
      this.$http.get('/dbapi/product_replace?product_id=' + this.$route.params.id).then(data => {
        this.replaces = data.list
      })
    },
    fetchHolds () {
      this.$http.get('/dbapi/reserved_list?product_id=' + this.$route.params.id).then(data => {
        this.holds = data.list
      })
    },
    fetchDocList () {
      this.$http.get('/dbapi/product_doc_list?product_id=' + this.$route.params.id).then(data => {
        this.docs = data.list
      })
    },
    fetchPhotoList () {
      this.$http.get('/dbapi/product_photo_list?product_id=' + this.$route.params.id).then(data => {
        this.photos = data.list
      })
    }
  }
}
</script>

<style lang="scss">
.product-window {
  .product-table {
    td {
      padding: 4px;
      border-right: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      word-break: break-all;
      &.label {
        width: 200px;
      }
    }
  }
  .stock-table {
    background-color:#e2ecf9;
  }
}
</style>

